var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.8333V10.8333H7V12.8333H5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.8333H11V10.8333H9V12.8333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.8333H13V10.8333H15V12.8333Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.8333V16.8333H7V14.8333H5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.8333H9V14.8333H11V16.8333Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0.833252C15.5523 0.833252 16 1.28097 16 1.83325V2.83325H17C18.6569 2.83325 20 4.1764 20 5.83325V17.8333C20 19.4902 18.6569 20.8333 17 20.8333H3C1.34315 20.8333 0 19.4902 0 17.8333V5.83325C0 4.1764 1.34315 2.83325 3 2.83325H4V1.83325C4 1.28097 4.44772 0.833252 5 0.833252C5.55228 0.833252 6 1.28097 6 1.83325V2.83325H14V1.83325C14 1.28097 14.4477 0.833252 15 0.833252ZM2 17.8333C2 18.3856 2.44772 18.8333 3 18.8333H17C17.5523 18.8333 18 18.3856 18 17.8333V8.83325H2V17.8333ZM3 4.83325C2.44772 4.83325 2 5.28097 2 5.83325V6.83325H18V5.83325C18 5.28097 17.5523 4.83325 17 4.83325H3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDates);
export default __webpack_public_path__ + "static/media/calendar-dates.27371fd5.svg";
export { ForwardRef as ReactComponent };